import { usersCollection } from '../../firebase'
export default {
  namespaced: true,
  state: {
    params: {},
    type: null,
    unsubscribeFn: null
  },
  mutations: {
    setParams (state, params) {
      state.params = params
      state.type = params.shopifyAccessToken ? 'shopify' : 'csv'
    },
    setUnsubscribe (state, unsubscribeFn) {
      state.unsubscribeFn = unsubscribeFn
    }
  },
  actions: {
    async fetchUserParams ({ commit }, user) {
      const userUid =
      // special rule for development env
      process.env.VUE_APP_ENV === 'development' && user.isAnonymous
        ? 'shopify:' + process.env.VUE_APP_SHOPIFY_STORE
        : user.uid
      const userDocRef = usersCollection.doc(userUid)
      const userDoc = await userDocRef.get()
      const data = userDoc.data()
      if (data.mapVizParams && !data.customersDataset) data.customersDataset = 'customers.customer_19_abridged' // TODO: remove once params is set by webservice
      commit('setParams', data)
      // add a listener on user data
      const unsubscribeFn = userDocRef
        .onSnapshot(doc => {
          const data = doc.data()
          if (data.mapVizParams && !data.customersDataset) data.customersDataset = 'customers.customer_19_abridged' // TODO: remove once params is set by webservice
          commit('setParams', data)
        })
      commit('setUnsubscribe', unsubscribeFn)
    }
  }
}
